/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  SignUpFirmRequest,
  SignupUserResponse,
  UserSlimDto,
  ValidateSignupUserRequest,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class FirmSignupController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags firm-signup-controller
   * @name SignUpFirm
   * @request POST:/api/v1/accounting-firm/signup
   */
  signUpFirm = (data: SignUpFirmRequest, params: RequestParams = {}) =>
    this.http.request<UserSlimDto, any>({
      path: `/v1/accounting-firm/signup`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static signUpFirmPath = '/v1/accounting-firm/signup'
  static signUpFirmMethod = 'POST'
  /**
   * No description
   *
   * @tags firm-signup-controller
   * @name ValidateUser
   * @request POST:/api/v1/accounting-firm/signup/user/validate
   */
  validateUser = (data: ValidateSignupUserRequest, params: RequestParams = {}) =>
    this.http.request<SignupUserResponse, any>({
      path: `/v1/accounting-firm/signup/user/validate`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static validateUserPath = '/v1/accounting-firm/signup/user/validate'
  static validateUserMethod = 'POST'
}
